import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import 'bootstrap/dist/css/bootstrap.min.css';
import { loadConfig } from "./config";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Load config.xml before rendering the application
loadConfig().then(() => {
    root.render(<App />);
});
